import React, { useState } from 'react';

const stop = (e) => e.preventDefault();

/* "20 Over KEN Last Digit" — a back-only market. Each row shows a single best
   BACK price; the two leading `back-light` buttons are kept but hidden
   (visibility:hidden) so the value aligns under the BACK header, exactly like
   the reference. Reuses the shared market_section shell + .collapse. */
export default function LastDigitMarket({ market, onSelectBet }) {
  const [open, setOpen] = useState(true);
  const pick = (row) => onSelectBet && row.p && onSelectBet({ side: 'back', team: row.name, odds: row.p, marketName: market.title });
  return (
    <div className="market_section">
      <div>
        <p>
          <span className="mrkname">{market.title}</span>
          <a href="#!" className="add-pin" onClick={stop} title="Pin"><i className="bi bi-bookmark" /></a>
          <span className="min-max">{` ${market.minmax} `}
            <a href="#!" className="ms-2 game-rules-icon" onClick={stop} title="Rules"><span><i className="bi bi-info-square-fill" /></span></a>
            <a href="#!" className="an-collapse" onClick={(e) => { stop(e); setOpen((o) => !o); }} aria-expanded={open} />
          </span>
        </p>
        <div className={`collapse${open ? ' show' : ''}`}>
          <div>
            <div className="row align-items-center oddsHeader">
              <div className="col-lg-6 col-md-5 col-8 px-0" />
              <div className="col-lg-6 col-md-7 col-4 px-0">
                <div className="btn-group">
                  <button type="button" className="ex-bl d-none d-md-block" />
                  <button type="button" className="ex-bl d-none d-md-block" />
                  <button type="button" className="back">back</button>
                </div>
              </div>
            </div>
            {market.rows.map((row, i) => (
              <div key={i}>
                <div className="row mx-0 align-items-center book_maker_type_4">
                  <div className="col-lg-6 col-md-5 col-8 px-0">
                    <span className="marketevent">{row.name}</span>
                  </div>
                  <div className="col-lg-6 col-md-7 col-4 px-0">
                    <div className="btn-group">
                      <button type="button" className="back back-light d-none d-md-block" style={{ visibility: 'hidden' }} />
                      <button type="button" className="back back-light d-none d-md-block" style={{ visibility: 'hidden' }} />
                      <button type="button" className="back" onClick={() => pick(row)}><span>{row.p}</span><small>{row.v}</small></button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
